// extracted by mini-css-extract-plugin
export default {"avatarIcon":"AvatarIcon_avatarIcon__jMW40"};